import { COUNTRY_UPDATE } from "../constants/countryConstants";

export const updateCountry = (data) => (dispatch) => {
	dispatch({
		type: COUNTRY_UPDATE,
		payload: data,
	});
	// localStorage.setItem("country", JSON.stringify(data));
};
